module.exports = __webpack_public_path__ + "static/media/lds-logo_mn.ccc860d0.svg";